import { render, staticRenderFns } from "./AttachmentsArea.vue?vue&type=template&id=84845798&scoped=true&"
import script from "./AttachmentsArea.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsArea.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsArea.vue?vue&type=style&index=0&id=84845798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84845798",
  null
  
)

export default component.exports